import { z } from 'zod';

export const notificationItemSchema = z.object({
  id: z.string().uuid(),
  type: z.string(),
  category: z.string(),
  title: z.string(),
  body: z.string(),
  icon: z.string(),
  icon_color: z.string(),
  action_url: z.string().nullable(),
  metadata: z.record(z.string(), z.unknown()),
  is_read: z.boolean(),
  created_at: z.string(),
});

export type NotificationItemDto = z.infer<typeof notificationItemSchema>;

export const notificationFeedResponseSchema = z.object({
  notifications: z.array(notificationItemSchema),
  next_cursor: z.string().nullable(),
  has_more: z.boolean(),
});

export type NotificationFeedResponse = z.infer<typeof notificationFeedResponseSchema>;

export const unreadCountResponseSchema = z.object({
  count: z.number().int().min(0),
});

export type UnreadCountResponse = z.infer<typeof unreadCountResponseSchema>;

export const notificationPreferencesResponseSchema = z.object({
  notificationsEnabled: z.boolean(),
  hasSeenNotificationPanel: z.boolean(),
  categories: z.array(
    z.object({
      category: z.string(),
      enabled: z.boolean(),
    }),
  ),
});

export type NotificationPreferencesResponse = z.infer<typeof notificationPreferencesResponseSchema>;

export const updateNotificationPreferencesRequestSchema = z
  .object({
    notificationsEnabled: z.boolean().optional(),
    hasSeenNotificationPanel: z.boolean().optional(),
    categories: z
      .array(
        z.object({
          category: z.string().min(1),
          enabled: z.boolean(),
        }),
      )
      .optional(),
  })
  .refine(
    data =>
      data.notificationsEnabled !== undefined ||
      data.hasSeenNotificationPanel !== undefined ||
      (data.categories !== undefined && data.categories.length > 0),
    { message: 'At least one field is required' },
  );

export type UpdateNotificationPreferencesRequest = z.infer<typeof updateNotificationPreferencesRequestSchema>;

export type NotificationFilter = 'all' | 'unread';
